export default "/assets/images/mila-valentine-mobile.6ac7ca41c0279f2e.png";